module.exports = __webpack_public_path__ + "static/media/campaigns.a8670d69.svg";